import React from "react";
import {Typography} from "@material-ui/core";

const Login = props => {
    return (
        <div>
            <Typography variant="h4">Please log in to view this content.</Typography>
        </div>
    )
}

export default Login;
